window.addEventListener("DOMContentLoaded", () => {
   $('body').on('click','.header-popup-btn',function(e){
     e.stopPropagation()
     e.preventDefault();
        $('.popup-header').addClass('open');
        $('html').addClass('overflow-hidden');
      });
$('body').on('click','.popup-header .close-icon',function(){
  $('html').removeClass('overflow-hidden');
  $(this).closest('.popup-header').removeClass('open');
});
  
  const testimonialHeadings = document.querySelectorAll(
    ".testimonial__heading"
  );
  const testimonialOverlays = document.querySelectorAll(
    ".testimonial-section__overlay"
  );

  const addOverlayOnLeft = () => {
    testimonialOverlays.forEach((testimonialOverlay) => {
      testimonialHeadings.forEach((testimonialHeading) => {
        testimonialOverlay.style.width =
          testimonialHeading.offsetLeft - 10 + "px";
      });
    });
  };

  addOverlayOnLeft();

  window.addEventListener("resize", addOverlayOnLeft);

  const testimonialTrack = document.querySelector(
    ".testimonial__slider .slick-track"
  );
  testimonialTrack &&
    testimonialTrack.addEventListener("mousedown", () => {
      testimonialTrack.classList.add("mouse-grabbing");
    });
  testimonialTrack &&
    testimonialTrack.addEventListener("mouseup", () => {
      testimonialTrack.classList.remove("mouse-grabbing");
    });
});


document.addEventListener('DOMContentLoaded', function() {
  const dropdownMenuItems = document.querySelectorAll('header-menu details');

  dropdownMenuItems.forEach((dropdownMenuItem) => {
    dropdownMenuItem.addEventListener('mouseenter', function(e) {
      e.currentTarget.setAttribute("open", true);
    });
  
    dropdownMenuItem.addEventListener('mouseleave', function(e) {
      e.currentTarget.removeAttribute("open", true);
    });
  });
});
